import Box from '@sendsprint/ui-react/dist/components/Box';
import Button from '@sendsprint/ui-react/dist/components/Button';
import ExtraInfo from '@sendsprint/ui-react/dist/components/ExtraInfo';
import FormField from '@sendsprint/ui-react/dist/components/Form/formInput';
import FormFieldTextarea from '@sendsprint/ui-react/dist/components/Form/formTextarea';
import FormFieldWithExternalLabel from '@src/components/form/FormFieldWithExternalLabel';
import React from 'react';
import TargetCurrencyField from '../targetCurrencyField';
import { UsePaymentLinkFormResponse } from '../../../hooks/usePaymentLinkForm';
import VeriffModal from '@src/components/veriffModal';

interface Props {
  paymentLinkResponse: UsePaymentLinkFormResponse;
}

const PaymentLinkFormContent = ({ paymentLinkResponse }: Props) => {
  const { isLoading, buttonLabel, shouldDisableForm, handleVeriffModalClose, showVeriffModal } =
    paymentLinkResponse;
  return (
    <>
      <Box className="ss-bg-white ss-space-y-3 ss-p-4 ss-rounded-lg ss-mb-5">
        <p className="ss-text-neutral-400 ss-text-sm">
          Enter the details to generate a link. Links are securely sent.
        </p>
        {shouldDisableForm && (
          <ExtraInfo
            extraInfo="Payment link currently disabled. To update this payment link, you need to enable it."
            variant="warning"
          />
        )}
      </Box>
      <Box className="ss-bg-white ss-space-y-3 ss-p-4 ss-rounded-lg ss-mb-5">
        <FormFieldWithExternalLabel label="Link name">
          <FormField name="linkName" label="Link name" />
        </FormFieldWithExternalLabel>
        <TargetCurrencyField />
        <FormFieldWithExternalLabel label="Amount">
          <FormField
            name="amount"
            label="Amount"
            type="number"
            extraInfo="To allow customers enter desired amount, leave the box empty"
          />
        </FormFieldWithExternalLabel>
        <FormFieldWithExternalLabel label="Description">
          <FormFieldTextarea name="description" label="Description" />
        </FormFieldWithExternalLabel>
        <FormFieldWithExternalLabel label="Redirect URL after payment">
          <FormField name="redirectUrl" label="Enter URL" />
        </FormFieldWithExternalLabel>
      </Box>
      <Box>
        <Button
          showSpinner={isLoading}
          disabled={isLoading || shouldDisableForm}
          type="submit"
          isBlock
          label={buttonLabel}
        />
      </Box>
      <VeriffModal state={showVeriffModal} handleClick={handleVeriffModalClose} />
    </>
  );
};

export default PaymentLinkFormContent;
